import comp from "./CourseSelectionPage";
export default comp;
